import type { LensTheme } from '@diligentcorp/atlas-theme-mui-lens';
import { Box, Stack, Typography, useTheme } from '@mui/material';
import React from 'react';
import { Control, Controller } from 'react-hook-form';
import type { FormValues } from '../../organisms/AddRuleDrawer/useAddRuleDrawer';
import { Dropdown, DropdownOption } from '../Dropdown';
import { SectionHeader } from '../SectionHeader/SectionHeader';

interface Props {
  control: Control<FormValues>;
  ruleTypeOptions: DropdownOption[];
  countryOptions: DropdownOption[];
  isLoadingDropdown: boolean;
  showCountryError: boolean;
  showRuleTypeError: boolean;
}

export const NewRuleSection: React.FC<Props> = ({
  control,
  ruleTypeOptions,
  countryOptions,
  isLoadingDropdown,
  showCountryError,
  showRuleTypeError,
}) => {
  const theme = useTheme<LensTheme>();
  const sp = theme.tokens.semantic.spacing.desktop.gap;
  const color = theme.tokens.semantic.color;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: sp[3].value,
        paddingTop: sp[4].value,
      }}
    >
      <SectionHeader
        title="New Rule"
        subtitle="Define the country and rule type this retention policy should apply"
      />
      <Stack sx={{ flexDirection: 'column', gap: sp[2].value }}>
        <Stack sx={{ flexDirection: 'column', gap: sp[1].value }}>
          <Typography
            sx={{
              fontSize: '12px',
              fontWeight: 600,
              color: color.type.default.value,
              m: 0,
            }}
          >
            Rule type
          </Typography>
          <Controller
            name="selectedRuleType"
            control={control}
            render={({ field }) => (
              <Dropdown
                placeholder="Select rule type"
                value={field.value}
                onChange={field.onChange}
                options={ruleTypeOptions}
                data-testid="rule-type-dropdown"
                error={
                  showRuleTypeError
                    ? 'Country Rule Type is required'
                    : undefined
                }
              />
            )}
          />
        </Stack>
        <Stack sx={{ flexDirection: 'column', gap: sp[1].value }}>
          <Typography
            sx={{
              fontSize: '12px',
              fontWeight: 600,
              color: color.type.default.value,
              m: 0,
            }}
          >
            Country
          </Typography>
          <Controller
            name="selectedCountry"
            control={control}
            render={({ field }) => (
              <Dropdown
                placeholder="Select country"
                value={field.value}
                onChange={field.onChange}
                options={countryOptions}
                disabled={isLoadingDropdown}
                data-testid="country-dropdown"
                error={showCountryError ? 'Country is required' : undefined}
              />
            )}
          />
        </Stack>
      </Stack>
    </Box>
  );
};
